import ApiService from "@/core/services/ApiService";
import JwtService from "@/core/services/JwtService";
import { Actions, Mutations } from "@/store/enums/StoreEnums";
import { Module, Action, Mutation, VuexModule } from "vuex-module-decorators";

export interface ProgressModule {
  name: string;
  api_token: string;
}

export interface ProgressModuleListInfor {
  errors: unknown;
  feedback: ProgressModule;
  isAuthenticated: boolean;
}

@Module
export default class ProgressModuleModule
  extends VuexModule
  implements ProgressModuleListInfor
{
  errors = {};
  feedback = {} as ProgressModule;
  isAuthenticated = !!JwtService.getToken();

  get ProgressList() {
    return this.infoCollectionProgressListData;
  }

  get ProgressDetail() {
    return this.infoCollectionProgressDetailData;
  }

  get ProgressApi() {
    return this.infoCollectionProgressApiData;
  }

  @Mutation
  [Mutations.INFO_COLLECTION_PROGRESS_LIST_DATA](ProgressList) {
    this.infoCollectionProgressListData = ProgressList;
  }

  @Mutation
  [Mutations.INFO_COLLECTION_PROGRESS_DETAIL_DATA](ProgressDetail) {
    this.infoCollectionProgressDetailData = ProgressDetail;
  }

  @Mutation
  [Mutations.INFO_COLLECTION_PROGRESS_API_DATA](ProgressApi) {
    this.infoCollectionProgressApiData = ProgressApi;
  }

  @Action
  [Actions.INFO_COLLECTION_PROGRESS_LIST](payload) {
    if (JwtService.getToken()) {
      ApiService.setHeader();
      return ApiService.post("tiendo-dieutra", payload)
        .then((data) => {
          this.context.commit(
            Mutations.INFO_COLLECTION_PROGRESS_LIST_DATA,
            data
          );
        })
        .catch(({ response }) => {
          this.context.commit(Mutations.PURE_AUTH_AND_SET_ERROR, response.data);
        });
    } else {
      this.context.commit(Mutations.PURGE_AUTH);
    }
  }

  @Action
  [Actions.INFO_COLLECTION_PROGRESS_DETAIL](payload) {
    return ApiService.getDataDetail(
      "/tiendo-dieutra",
      payload,
      "detail",
      payload
    )
      .then(({ data }) => {
        this.context.commit(
          Mutations.INFO_COLLECTION_PROGRESS_DETAIL_DATA,
          data
        );
      })
      .catch(({ response }) => {
        this.context.commit(Mutations.PURE_AUTH_AND_SET_ERROR, response.data);
      });
  }

  @Action
  [Actions.INFO_COLLECTION_PROGRESS_API](payload) {
    if (JwtService.getToken()) {
      return ApiService.getDataDetail(
        "/tiendo-dieutra",
        payload,
        "detail-api",
        payload
      )
        .then((data) => {
          this.context.commit(
            Mutations.INFO_COLLECTION_PROGRESS_API_DATA,
            data
          );
          this.context.commit(Mutations.SET_ERROR, {});
        })
        .catch(({ response }) => {
          this.context.commit(Mutations.PURE_AUTH_AND_SET_ERROR, response.data);
        });
    }
  }
}
